exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-content {\n    width: 300px;\n}\n\n.mat-dialog-content .file {\n    height: 75px;\n}\n\n.mat-dialog-content .sample {\n    height: 25px;\n}\n\n.mat-dialog-content .mappers {\n    height: 75px;\n}\n\n.mat-dialog-content .error p {\n    background-color: #ffcccc;\n    border: #ffaaaa solid 1px;\n    border-radius: 5px;\n    max-height: 100px;\n    max-width: 100%;\n    overflow: scroll;\n    padding: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/file-uploader-dialog/file-uploader-dialog.component.css
// module id = ../../../../../src/app/shared/components/file-uploader-dialog/file-uploader-dialog.component.css
// module chunks = main